export default function () {
	return {
		progress: 'all',
		search: '',
		loading: false,
		selected_areas: {
			value: 'all'
		},
		presential_status: null,
		presential_is_online: false,
		selected_groups: {
			value:'all'
		},
		selected_tags: {
			value:'all'
		}
	}
}
